import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';

import { updateDefinitionExpression } from '../../controllers/esriMapController';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  formControl: {
    margin: theme.spacing(1)
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  outlinedInput: {
    fontWeight: 400,
    padding: '6px 20px 6px 6px',
    background: theme.palette.secondary.main,
    fontSize: theme.typography.pxToRem(13)
  }
}));

export default function YearSelector(props) {
  const classes = useStyles();

  const [year, setYear] = React.useState(props.max);
  function handleChange(event) {
    setYear(event.target.value);
    updateDefinitionExpression(event.target.value, props.layerId);
  }

  const { min, max } = props;

  const years = [];
  for (let i = max; i >= min; i--) {
    years.push(i);
  }

  return (
    <form className={`year-selector ${classes.root}`} autoComplete="off">
      <FormControl classes={{ root: classes.formControl }}>
        <Select
          value={year}
          onChange={handleChange}
          classes={{ root: classes.outlinedInput }}
          inputProps={{
            name: 'Year',
            className: 'year-simple'
          }}
          input={
            <OutlinedInput
              classes={{ input: classes.outlinedInput }}
              name={'Day of the week'}
              labelWidth={0}
            />
          }
        >
          {years.map((yearValue, i) => {
            return (
              <MenuItem key={i} value={yearValue}>
                {yearValue}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </form>
  );
}
